import styles from "./Footer.module.scss";
import packageJson from "../../../package.json";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <div className={styles.base}>
      {year} - developed with ❤️ by exodie |{` v${packageJson.version}`}
      <br />
      <span>In the future rewrite to Next.js & more languages.</span>
    </div>
  );
}

export default Footer;
